module.exports = __webpack_public_path__ + "static/media/dev-icon-1.7f8f60c3.svg";